import { getPath } from '@/router/common'
const baseUrl = {
  title: '发货库存',
  path: 'fhkc'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'fhkc_index',
    component: () => import(/* webpackChunkName: "fhkc_index" */ '@/views/fhkc/index/index.vue'),
    meta: {
      title: '发货库存'
    }
  },
  // 定制： 拼单库存
  {
    path: getPath('pdkc', baseUrl),
    name: 'fhkc_pdkc',
    component: () => import(/* webpackChunkName: "fhkc_pdkc" */ '@/views/fhkc/pdkc/index.vue'),
    meta: {
      title: '拼单库存'
    }
  }
]
